import { render } from "./DailyReport.vue?vue&type=template&id=f9845d34&scoped=true"
import script from "./DailyReport.vue?vue&type=script&lang=js"
export * from "./DailyReport.vue?vue&type=script&lang=js"

import "./DailyReport.vue?vue&type=style&index=0&id=f9845d34&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9845d34"]])

export default __exports__